<template>
  <div class="policy-descriptions">
    <Skeleton v-if="loading" :height="20" :width="150"></Skeleton>
    <div v-if="!loading">
       <span class="label" :style=statusColor>{{ statusDescription }}</span>
    </div>
  </div>
</template>

<script>
import policyApi from "~/api/policy";
import {Skeleton} from 'vue-loading-skeleton';

export default {
  name: "PolicyStatusComponent",
  components: {Skeleton},
  props: {
    policyId: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      statusDescription: '',
      statusColor: {
        backgroundColor: ''
      },
      loading: true
    }
  },
  computed: {},
  methods: {
    loadStatus() {
      policyApi.getById(this.policyId).then(response => {
        this.loading = false;
        this.statusDescription = response.data.status.description;
        this.statusColor.backgroundColor = response.data.status.color;
      }).catch(error => {
        this.loading = false;
      });
    },
  },
  mounted() {
    this.loadStatus();
  }
}
</script>
<style scoped>

</style>
